import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Cookies, withCookies } from 'react-cookie';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import Scroll from 'react-scroll';
import { isMobile } from 'react-device-detect';

import SiteLayout from '../../../layouts/SiteLayout/SiteLayout';
import DiscountMessage from '../../../payments/BasketDiscountMessages/DiscountMessage/DiscountMessage';
import SelectPackageForm from '../../../payments/SelectPackageForm/SelectPackageForm';
import { fetchSiteProductsAction } from '../../../../store/pricingDucks/siteProducts';
import { addProductsToBasketAction } from '../../../../store/pricingDucks/chosenProducts';
import OrderExpiredView from '../../paymentJourney/OrderExpiredView/OrderExpiredView';
import ServerErrorView from '../../siteBasePages/ServerErrorView/ServerErrorView';
import { localizePath } from '../../../../helpers/locale';
import gtmService from '../../../../utils/gtm';
import { canCookieBeSecure } from '../../../../helpers';
import { withPaymentJourney } from '../../paymentJourney/hocs/withPaymentJourney/withPaymentJourney';
import addPreviewPrefixToUrl from '../../../../helpers/preview/addPreviewPrefixToUrl';
import { pushAddToCartForGTM } from '../../../paymentJourneyRedesign/helpers/shared/pushAddToCartForGTM';

const MAIN_MENU_HEIGHT = isMobile ? 55 : 65;

export class SelectPackageView extends Component {
  constructor(props) {
    super(props);

    this.onChangeForm = this.onChangeForm.bind(this);
    this.onSubmitForm = this.onSubmitForm.bind(this);
    this.scrollToError = this.scrollToError.bind(this);
  }

  componentDidMount() {
    const { siteProducts } = this.props;

    if (siteProducts.booking) {
      const products = siteProducts.data.productTypesWithProducts.flatMap(
        (itemPackage) => {
          return itemPackage.products.map(({ name, id, price }) => ({
            name,
            brand: name,
            id,
            price,
          }));
        },
      );

      gtmService.pushProductDetails(products);

      const { divisionId, divisionInfrontBusinessUnit, divisionName } =
        siteProducts.meta;

      gtmService.pushDivisionOption({
        divisionId,
        divisionInfrontBusinessUnit,
        divisionName,
      });
    }
  }

  scrollToError() {
    const hasErrorElements = document.querySelectorAll('.has-error');
    if (hasErrorElements && hasErrorElements.length) {
      const errorOffsetTop =
        hasErrorElements[0].getBoundingClientRect().top +
        window.scrollY -
        MAIN_MENU_HEIGHT; // TODO: should be updated when it will be stored in redux
      Scroll.animateScroll.scrollTo(errorOffsetTop);
    }
  }

  fetchSiteProducts(queryParams) {
    const basketId = this.props.cookies.get('basket_id');
    const optionIndex = this.props.match?.params?.optionIndex;

    this.props.fetchSiteProducts(basketId, queryParams, optionIndex);
  }

  getSitePath() {
    const {
      pageConfig: { sitePath, singleSiteMode },
    } = this.props;

    return singleSiteMode ? '' : `/${sitePath}`;
  }

  addProductsToBasket(queryParams, bodyParams) {
    const { match: { params: { optionIndex } = {} } = {}, siteProducts } =
      this.props;
    const basketId = this.props.cookies.get('basket_id');

    if (optionIndex) {
      bodyParams.siteOptionIndex = optionIndex;
    }

    this.props.addProductsToBasket(
      basketId,
      queryParams,
      bodyParams,
      (data) => {
        const {
          i18n,
          pageConfig: { cookieSitePath, location = {} } = {},
          options: { data: { locales: { primary } = {} } = {} } = {},
        } = this.props;

        if (data.statusCode === 200) {
          const productIds = (bodyParams.packageSelection || []).flatMap(
            ({ productId, optionIds = [] }) => [productId, ...optionIds],
          );

          pushAddToCartForGTM(
            {
              currency: siteProducts.data.currency,
              productTypesWithProducts:
                siteProducts.data.productTypesWithProducts,
              optionalProductTypesWithProducts:
                siteProducts.data.optionalProductTypesWithProducts,
            },
            productIds,
            Number(bodyParams.quantity),
          );

          this.props.cookies.set('basket_order', basketId, {
            path: cookieSitePath,
            expires: new Date(Date.now() + 86400000),
            secure: canCookieBeSecure(),
          });
          const localizedUrl = localizePath(
            `${this.getSitePath()}/purchase/view-basket`,
            i18n.language,
            primary,
          );

          document.location.href = addPreviewPrefixToUrl({
            url: localizedUrl,
            hostname: location.hostname,
            pathname: location.pathname,
          });
        } else {
          if (data.errors) {
            this.setState(
              () => ({
                errors: data.errors,
              }),
              () => this.scrollToError(),
            );
          }
        }
      },
    );
  }

  onChangeForm(props) {
    const {
      quantity,
      delegateTypeId,
      productIds,
      country,
      region,
      taxIdExemption,
      vatNumber,
      resident,
      carbonOffset,
    } = props;
    const vipCode = this.props.cookies.get('vip_code');
    this.fetchSiteProducts({
      quantity,
      carbonOffset,
      delegateTypeId,
      productIds,
      vipCode,
      country,
      region,
      taxIdExemption,
      vatNumber,
      resident,
    });
  }

  onSubmitForm(props) {
    const {
      carbonOffset,
      quantity,
      delegateTypeId,
      packageSelection,
      country,
      region,
      taxIdExemption,
      vatNumber,
      resident,
    } = props;
    const bodyParams = {
      carbonOffset,
      quantity,
      delegateTypeId,
      packageSelection,
      taxIdExemption,
      vatNumber,
      resident,
    };
    if (country && country.length) bodyParams.country = country;
    if (region && region.length) bodyParams.region = region;
    const queryParams = {
      promoCode: this.props.cookies.get('vip_code'),
      tracker_id: this.props.cookies.get('tracker_id'),
      skip_delegates: this.props.cookies.get('skip_delegates') === 'true',
    };

    this.addProductsToBasket(queryParams, bodyParams);
  }

  render() {
    const {
      siteHeader: {
        data: {
          bookingMetaTitle,
          bookingMetaDescription,
          bookingHideFromSearchEngines,
        },
        meta: { title } = {},
      } = {},
      options: { data: { deliveryType } = {} } = {},
      chosenProducts: { statusCode: chosenProductsStatusCode } = {},
      siteProducts: {
        loaded = false,
        statusCode: siteProductsStatusCode,
        data = {},
        meta = {},
        meta: { promotionalDiscount: { discount } = {} } = {},
      } = {},
      t,
    } = this.props;
    const errors = this.state?.errors;

    if (siteProductsStatusCode === 410 || chosenProductsStatusCode === 410) {
      return <OrderExpiredView />;
    }

    if (siteProductsStatusCode >= 400) {
      return <ServerErrorView />;
    }

    const pageMetaTitle = `${
      bookingMetaTitle || t('event.book-now')
    } | ${title}`;

    return (
      <SiteLayout
        footerUpperHidden
        helmet={{
          title: pageMetaTitle,
          description: bookingMetaDescription,
          meta: {
            robots: bookingHideFromSearchEngines
              ? 'noindex, nofollow'
              : 'index, follow',
          },
        }}
      >
        {discount && (
          <div className="container">
            <DiscountMessage data={{ discount, success: true }} />
          </div>
        )}
        <SelectPackageForm
          loaded={loaded}
          deliveryType={deliveryType}
          data={data}
          meta={meta}
          errors={errors}
          onChange={this.onChangeForm}
          onSubmit={this.onSubmitForm}
          scrollToError={this.scrollToError}
        />
      </SiteLayout>
    );
  }
}

SelectPackageView.propTypes = {
  siteHeader: PropTypes.shape({
    data: PropTypes.shape({
      bookingMetaTitle: PropTypes.string,
      bookingMetaDescription: PropTypes.string,
      bookingHideFromSearchEngines: PropTypes.bool,
    }),
    meta: PropTypes.shape({
      title: PropTypes.string,
    }),
  }),
  siteProducts: PropTypes.shape({
    data: PropTypes.object,
    meta: PropTypes.object,
  }),
  chosenProducts: PropTypes.shape({
    data: PropTypes.object,
    meta: PropTypes.object,
  }),
  options: PropTypes.shape({
    data: PropTypes.shape({
      deliveryType: PropTypes.string,
      locales: PropTypes.shape({
        primary: PropTypes.string,
      }),
    }),
  }),
  cookies: PropTypes.instanceOf(Cookies),
};

function mapStateToProps(state) {
  return {
    siteHeader: state.siteHeader,
    siteProducts: state.siteProducts,
    chosenProducts: state.chosenProducts,
    pageConfig: state.pageConfig,
    options: state.options,
    booking: state.siteProducts,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchSiteProducts(basketId, queryParams, optionIndex) {
      return dispatch(
        fetchSiteProductsAction(basketId, queryParams, optionIndex),
      );
    },
    addProductsToBasket(basketId, queryParams, bodyParams, callback) {
      return dispatch(
        addProductsToBasketAction(basketId, queryParams, bodyParams, callback),
      );
    },
  };
}

export default withTranslation()(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withRouter(withPaymentJourney(withCookies(SelectPackageView)))),
);
